import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, dark = false, align = "center" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-14 sm:mb-20`}>
    {eyebrow && (
      <p
        className={`text-xs uppercase tracking-[0.25em] font-bold mb-4 ${
          dark ? "text-gold" : "text-gold"
        }`}
      >
        {eyebrow}
      </p>
    )}
    <h2
      className={`font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-balance ${
        dark ? "text-ivory" : "text-forest"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p
        className={`mt-5 text-base sm:text-lg leading-relaxed ${
          dark ? "text-ivory/70" : "text-inkmuted"
        }`}
      >
        {sub}
      </p>
    )}
  </Reveal>
);

export const CTAButton = ({
  children,
  onClick,
  href,
  variant = "primary",
  className = "",
  testid,
  type = "button",
}) => {
  const styles =
    variant === "primary"
      ? "bg-forest text-ivory hover:bg-botanical shadow-card hover:shadow-hover"
      : variant === "gold"
      ? "bg-gold text-forest hover:bg-amber shadow-card hover:shadow-hover"
      : variant === "whatsapp"
      ? "bg-[#25D366] text-forest hover:bg-[#1fb857] shadow-card hover:shadow-hover font-bold"
      : "bg-transparent text-forest border border-forest/25 hover:border-forest hover:bg-forest/5";
  const cls = `inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold tracking-wide transition-colors duration-300 ${styles} ${className}`;
  if (href) {
    return (
      <motion.a
        whileHover={{ scale: 1.03, y: -2 }}
        whileTap={{ scale: 0.97 }}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className={cls}
      >
        {children}
      </motion.a>
    );
  }
  return (
    <motion.button
      whileHover={{ scale: 1.03, y: -2 }}
      whileTap={{ scale: 0.97 }}
      type={type}
      onClick={onClick}
      data-testid={testid}
      className={cls}
    >
      {children}
    </motion.button>
  );
};
